import MuiTabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Tabs = withStyles(styles)(MuiTabs);

export default Tabs;
